import Axios from './base';
 
export const GetMapLayers = () => Axios().get('MapLayers')
export const AddUpdateMapLayer = (entity) => Axios().post('MapLayers', entity)